import { render, staticRenderFns } from "./buyFullV.vue?vue&type=template&id=0fd26c72&scoped=true"
import script from "./buyFullV.vue?vue&type=script&lang=js"
export * from "./buyFullV.vue?vue&type=script&lang=js"
import style0 from "./buyFullV.vue?vue&type=style&index=0&id=0fd26c72&prod&scoped=true&lang=css"
import style1 from "./buyFullV.vue?vue&type=style&index=1&id=0fd26c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd26c72",
  null
  
)

export default component.exports